import Badge from '../ui/Badge';

export default function CategoryBadge({ category }) {
  if (!category) return null;

  const vehicle = category.vehicle_type === 'taxi' ? 'Taxi' : 'Bike';
  const location = category.location === 'outside_uae' ? 'Outside' : 'Inside';
  const license = category.license_type === 'uae' ? 'UAE Lic' : 'GCC Lic';

  return <Badge tone="gray">{`${vehicle} · ${location} · ${license}`}</Badge>;
}
